import injectSheet from 'react-jss';

import Dimmed from './component';
import styles from './slyles';

export default injectSheet(styles)(Dimmed);
